export default (newsId: string | number) => {
  return `/goto/${newsId.toString()}`;
}
